"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _classnames = _interopRequireDefault(require("classnames"));

var _useStyles = require("../../../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children"];
(0, _loadStyles.default)(".ca0ea0b7b{margin-left:.125rem;margin-right:.125rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;box-sizing:border-box;font-size:.875rem;font-weight:500;line-height:1rem;color:var(--color-gray-90)}.c0579df17{display:none}");
var styles = {
  value: 'ca0ea0b7b',
  '--invisible': 'c0579df17'
};
var AValueContainer = _reactSelect.components.ValueContainer;

var ValueContainer = function ValueContainer(props) {
  // eslint-disable-next-line
  var children = props.children,
      containerProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isMulti = containerProps.isMulti,
      hasValue = containerProps.hasValue;

  var _children = (0, _slicedToArray2.default)(children, 2),
      value = _children[0],
      input = _children[1];

  var cn = (0, _useStyles.useStyles)(styles, {});
  return /*#__PURE__*/_react.default.createElement(AValueContainer, (0, _extends2.default)({
    className: cn.valueContainer
  }, containerProps, {
    children: isMulti && hasValue ? [/*#__PURE__*/_react.default.createElement("div", {
      key: 0,
      className: (0, _classnames.default)(cn.value, (0, _defineProperty2.default)({}, cn.invisible, !!input.props.value))
    }, value.map(function (child) {
      return child.props.children;
    }).join(', ')), // eslint-disable-next-line
    children[children.length - 1]] : children
  }));
};

exports.ValueContainer = ValueContainer;